import React from 'react'
import cx from 'classnames'

import { Text, type TextColor } from 'components/dataDisplay'


export type OrderBillItemProps = {
  className?: string
  disabled?: boolean
  label: string | Intl.Message
  note?: string | Intl.Message
  noteColor?: TextColor
  value: string | Intl.Message
  isLarge?: boolean
  'data-testid': string
}

const OrderBillItem: React.FunctionComponent<OrderBillItemProps> = (props) => {
  const { className, disabled, label, note, noteColor, value, isLarge, 'data-testid': dataTestId } = props

  const priceColor = isLarge ? 'gold-50' : 'black'

  return (
    <div className={cx(className, 'flex justify-between')} data-testid={dataTestId}>
      <div>
        <Text
          message={label}
          style={isLarge ? 'p1' : 'p2'}
          color="black"
          data-testid={`${dataTestId}Label`}
        />
        {
          Boolean(note) && (
            <Text
              className="mt-4"
              message={note}
              style="p4"
              color={noteColor || 'gray-80'}
              html
              data-testid={`${dataTestId}Note`}
            />
          )
        }
      </div>
      <Text
        className="ml-16 whitespace-nowrap"
        message={value}
        style={isLarge ? 't1' : 't2'}
        color={disabled ? 'gray-50' : priceColor}
        data-testid={`${dataTestId}Value`}
      />
    </div>
  )
}


export default OrderBillItem
